import React from 'react';
import { createRoot } from 'react-dom/client';
import styled from 'styled-components';
import { ThemeProvider } from '@workboard/wobo-ui';
import { useTranslation } from 'react-i18next';
import BreadcrumbsItem from './Item';

import { IconType, IWrapperProps } from '../../types/teams.types';

const BreadcrumbsWrapper = styled.ul<React.HTMLProps<HTMLUListElement>>`
  display: flex;
  align-items: center;
  padding: 0 !important;
  margin: 0 !important;
  max-width: calc(100vw - 80px);
  overflow: hidden;

  > li {
    display: flex;
    align-items: center;
  }
`;

const Breadcrumbs = ({ teamName, teamType }: IWrapperProps): JSX.Element => {
  const { t } = useTranslation();
  const type = teamType !== 2 ? IconType.Functional : IconType.Dynamic;
  const urlParams = new URLSearchParams(window.location.search);
  const referralSource = urlParams.get('refSrc');

  return (
    <BreadcrumbsWrapper>
      <BreadcrumbsItem
        name={referralSource === 'OLP' ? t('My Objectives') : t('Teams')}
        iconType={IconType.Home}
        refSrc={referralSource}
      />
      <BreadcrumbsItem name={teamName} iconType={type} />
    </BreadcrumbsWrapper>
  );
};

const TeamBreadcrumb = (name, teamType): void => {
  createRoot(document.getElementById('teamsBreadcrumb')).render(
    <ThemeProvider>
      <Breadcrumbs teamName={name} teamType={teamType} />
    </ThemeProvider>,
  );
};

export default TeamBreadcrumb;
